import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { SimulationTrackerActions } from 'src/app/state/simulation-tracker/simulation-tracker.actions';


export const SimulationTrackerResolver: ResolveFn<boolean | null> = (
  route: ActivatedRouteSnapshot
) => {
  const store: Store = inject(Store);
  const simulationTrackerId: string | null = route.paramMap.get('simulationTrackerId');

  if (simulationTrackerId === null) {
    return null;
  }

  return store.dispatch(new SimulationTrackerActions.SelectSimulationTracker(simulationTrackerId)).pipe(
    map(() => true)
  );
};
